<mat-toolbar>
  <div class="header">
    <div class="header__logo" routerLink="/landing">
      <span>CBRE Finishline</span>
    </div>
    <div class="header__items">
      <div
        class="item language-menu"
        [class.custom-languages]="checkUserCountry()"
        [class.custom-language]="!checkUserCountry()">
        <a [matMenuTriggerFor]="languageMenu" [class.disabled]="getRouteName()">
          <div class="item flag flag-{{ userCountry }}"></div>
          <span class="label">{{ landingPageCountry }}</span>
          <span *ngIf="!getRouteName()">
            <mat-icon>arrow_drop_down</mat-icon>
          </span>
        </a>
        <mat-menu #languageMenu="matMenu" yPosition="below">
          <button mat-menu-item *ngFor="let countryList of countryLists" (click)="selectCountry(countryList, true)">
            <span>{{countryList.label}}</span>
          </button>
        </mat-menu>
      </div>

      <div class="item notifications">
        <a [ngClass]="{disableMenuClick: (unreadNotificationCount === 0)}" [matMenuTriggerFor]="notificationsMenu"
          (click)="getNotificationRecords()">
          <mat-icon aria-label="Notifications">notification_important</mat-icon>
          <span *ngIf="unreadNotificationCount > 0">{{unreadNotificationCount}}</span>
        </a>
        <mat-menu #notificationsMenu="matMenu" class="notifications-container">
          <mat-table #table [dataSource]="notificationDataSource">
            <ng-container matColumnDef="notification">
              <mat-header-cell *matHeaderCellDef>
                <h3><span i18n>Notification</span></h3>
              </mat-header-cell>
              <mat-cell class="notification-details" fxFlex="80" *matCellDef="let transaction"
                [ngClass]="'notificationSelectMenuItem'">
                <button mat-button [ngClass]="'notificationSelectButton'" [disabled]="disableTopNavClicks()"
                  (click)="openTransaction(transaction)">
                  <div class="notification-msg">{{transaction.alert}}</div>
                  <div class="notification-party-transaction">
                    <span class="rep-party">
                      {{transaction.represented_party}}
                    </span>|
                    <span>{{transaction.transaction}}</span>
                  </div>
                  <div class="notification-date">{{transaction.notification_date | date}}</div>
                </button>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dismiss">
              <mat-header-cell *matHeaderCellDef class="notification-dismiss-all">
                <button 
                  mat-button 
                  class="btn-dismiss-all" 
                  [disabled]="disableTopNavClicks()"
                  (click)="dismissAllNotifications()">
                  <h4><span i18n>Dismiss All </span>
                    <mat-icon class="notification-dismiss-icon">close</mat-icon>
                  </h4>
                </button>
              </mat-header-cell>
              <mat-cell class="notification-close" fxFlex="20" *matCellDef="let element">
                <button mat-button [disabled]="disableTopNavClicks()" (click)="dismissNotification(element.id)">
                  <mat-icon class="notification-dismiss-icon">close</mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *cdkHeaderRowDef="notificationColumns"></mat-header-row>
            <mat-row *cdkRowDef="let row; columns: notificationColumns;"></mat-row>
          </mat-table>
        </mat-menu>
      </div>

      <div *ngIf="role || isFinanceUser" class="item support" routerLink="{{ isFinanceUser ? '/dashboard/detailedReport' : '/dashboard/home' }}">
        <mat-icon aria-label="Support Dashboard">library_books</mat-icon>
      </div>

      <div class="item helper reports-cls" *ngIf="showReports">
        <img src="assets/images/finishline-reports.svg" alt="Reports" width="32" height="32" (click)="navigateToReports()"/>
      </div>
      
      <div class="item peoplesoft" ivClickOutSideDirective (clickoutside)="onClickedOutside($event)" *ngIf="!['CHN','SGP'].includes(userCountry)">
        <a (click)="showAddProject = !showAddProject"
          id="people-soft-link-button">
          <img src="assets/images/peoplesoft-top.svg" alt="PeopleSoft">
        </a>
        <!-- Add project prompt container -->
        <div class="arrow-box" *ngIf="showAddProject">
          <div *ngIf="userCountry !== 'IDN'">
            <button mat-raised-button class="new-invoice-button disable-ripple-effect" [disabled]="disableTopNavClicks()"
              (click)="navigateToLandingPage()">
              <mat-icon color="primary">add_circle</mat-icon><span i18n>Add/Update Customer</span>
            </button>
          </div>
          <div>
            <button mat-raised-button class="new-invoice-button disable-ripple-effect" [disabled]="disableTopNavClicks()"
              (click)="addPeopleSoftProject()" alt="add PeopleSoft project">
              <mat-icon color="primary">add_circle</mat-icon><span i18n>Add Project</span>
            </button>
          </div>
          <div class="prompt-text" i18n>
            (goes to the PeopleSoft site where</div>
          <div class="prompt-text" i18n> you can add a new project.)</div>
        </div>
      </div>

      <div class="item helper" routerLink="/help">
        <img src="assets/images/question-mark.svg" alt="Help">
      </div>

      <div class="item user">
        <div class="user__loaded" routerLink="/user/settings" *ngIf="isImageLoading">
          <img *ngIf="imageToShow" [src]="imageToShow" alt="User Profile"/>
          <mat-icon *ngIf="!imageToShow">person_filled</mat-icon>
        </div>
      </div>

    </div>
  </div>
</mat-toolbar>
